// extracted by mini-css-extract-plugin
export default {"noModulesIcon":"_3Y2lO24d"};